import { FaRegUserCircle } from "react-icons/fa";
import { AiFillHome } from "react-icons/ai";
import { MdCategory } from "react-icons/md";
import { GiVerticalBanner } from "react-icons/gi";
import { MdShoppingBag } from "react-icons/md";
import { RiDashboard2Line } from "react-icons/ri";
import { FaComments } from "react-icons/fa6";
import { FaShop } from "react-icons/fa6";
import { AiFillMessage } from "react-icons/ai";
import { RiMessage2Fill } from "react-icons/ri";
import { PiNotepadFill } from "react-icons/pi";

export const dataSidebar = [
  {
    link: "/",
    title: "Home",
    icon: <AiFillHome />,
  },
  {
    link: "/sellerInfo",
    title: "My info",
    icon: <FaShop />,
  },
  {
    link: "/shopInfo",
    title: "Shop info",
    icon: <FaShop />,
  },

  {
    link: "/product",
    title: "Products",
    icon: <MdShoppingBag />,
  },
  {
    link: "/contactadmin",
    title: "Contact admin",
    icon: <AiFillMessage />,
  },
  {
    link: "/contactcustomer",
    title: "Contact customer",
    icon: <RiMessage2Fill />,
  },
  {
    link: "/orders",
    title: "Orders",
    icon: <PiNotepadFill />,
  },
  {
    link: "/EarningsPayouts",
    title: "Earnings & Payouts",
    icon: <PiNotepadFill />,
  },
];
